
export * from './cadastros/vendedores/consulta-movimentacoes-vendedores/model-movimentacoes-vendedores/model-movimentacoes-vendedores.api';
export * from './cadastros/vendedores/consulta-credito-comissoes/model-credito-comissoes/model-credito-comissoes.api';
